export default "__VITE_ASSET__BRB4pRQ4__"